export default __webpack_public_path__ + "static/media/blog-img243.60435922.jpg";